// src/store/modules/login.js
const state = {
  userName: '',
  password: '',
  rememberMe: false
}

const mutations = {
  SET_LOGIN_INFO(state, { userName, password, rememberMe }) {
    state.userName = userName
    state.password = password
    state.rememberMe = rememberMe
  },
  CLEAR_LOGIN_INFO(state) {
    state.userName = ''
    state.password = ''
    state.rememberMe = false
  }
}

const actions = {
  saveLoginInfo({ commit }, loginInfo) {
    commit('SET_LOGIN_INFO', loginInfo)
  },
  clearLoginInfo({ commit }) {
    commit('CLEAR_LOGIN_INFO')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
